import React from 'react';
import Skeleton from './Skeleton';

/**
 * AnnouncementsSkeleton
 * Shimmer placeholder for the Announcements page:
 *   - header (title + New button)
 *   - search field + filter pills
 *   - stacked announcement-card placeholders
 * Built from the base <Skeleton /> block (pure Tailwind shimmer).
 */

const CARD =
  'bg-white dark:bg-[#262b33] rounded-[20px] border border-[#E3E9F3] dark:border-gray-800 shadow-[0_1px_2px_rgba(15,23,42,0.05),0_4px_10px_-3px_rgba(15,23,42,0.06)]';

const S = Skeleton;

const RowSkeleton = () => (
  <div className={`${CARD} pl-5 pr-6 py-[18px]`}>
    {/* icon + title + status pills */}
    <div className="flex items-start justify-between gap-4">
      <div className="flex items-start gap-3">
        <S className="w-9 h-9 rounded-xl shrink-0" />
        <S className="h-[18px] w-44 rounded-md mt-1.5" />
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <S className="h-5 w-14 rounded" />
        <S className="h-5 w-10 rounded" />
      </div>
    </div>
    {/* body lines */}
    <div className="mt-3 space-y-2">
      <S className="h-3 w-full rounded-md" />
      <S className="h-3 w-[85%] rounded-md" />
      <S className="h-3 w-[60%] rounded-md" />
    </div>
    {/* seen-by row */}
    <S className="h-3.5 w-28 rounded-md mt-4" />
    {/* footer: author + actions */}
    <div className="flex items-center justify-between mt-3 pt-3 border-t border-[#EEF2F8] dark:border-gray-800">
      <div className="flex items-center gap-2">
        <S className="w-7 h-7 rounded-full shrink-0" />
        <S className="h-3 w-32 rounded-md" />
      </div>
      <div className="flex items-center gap-1.5">
        <S className="w-7 h-7 rounded-lg" />
        <S className="w-7 h-7 rounded-lg" />
        <S className="w-7 h-7 rounded-lg" />
      </div>
    </div>
  </div>
);

const AnnouncementsSkeleton = () => (
  <div className="w-full pb-10">
    {/* Header */}
    <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-6">
      <div>
        <S className="h-7 w-52 rounded-xl" />
        <S className="h-3.5 w-72 rounded-md mt-3" />
      </div>
      <S className="h-[42px] w-[190px] rounded-xl" />
    </div>

    {/* Search + filter pills */}
    <div className="flex flex-col md:flex-row md:items-center gap-3 mb-6">
      <S className="h-10 w-full md:w-[320px] rounded-xl" />
      <S className="h-10 w-[340px] max-w-full rounded-full" />
    </div>

    {/* List */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      {Array.from({ length: 4 }).map((_, i) => <RowSkeleton key={i} />)}
    </div>
  </div>
);

export default AnnouncementsSkeleton;
